<template>
  <div>
    <span v-if="item">{{ item.name }}</span>
  </div>
</template>

<script>
export default {
 
  props: {
    item: { required: true },
    searchText: { required: true }
  }
}
</script>